export default "__VITE_ASSET__add9a02b__"